<template>
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>

    <div class="container">
    <div class="col-md-12" style="text-align: right !important;">
        <button type="button" class="btn btn-outline-warning" @click="regresar()">Cancelar</button>
    </div>
    <h3 style="text-align: left;">Cotización {{datos.folio}}</h3>
    <h5 style="text-align: left;">{{datos.email}}</h5>
    <br>
    <hr>
      <div class="row">
        <div class="col-md-4">
            <h3>Información General
            </h3>
          <table>
            <tr>
              <td>Nombre</td>
              <td>{{datos.razon_social}}</td>
            </tr>
            <tr>
              <td>RFC</td>
              <td></td>
            </tr>
            <tr>
              <td>Nombre del representante:</td>
              <td>{{datos.nombre_representante}}</td>
            </tr>
            <tr>
              <td>Correo del representante:</td>
              <td>{{datos.email}}</td>
            </tr>
            <tr>
              <td>Tipo:</td>
              <td>{{datos.tipo}}</td>
            </tr>
            <tr>
              <td>Domicilio:</td>
              <td>{{datos.domicilio}}</td>
            </tr>
            <tr>
              <td>Capacidad:</td>
              <td>{{datos.capacidad}}</td>
            </tr>
            <tr>
              <td>Voltaje de conexión:</td>
              <td>{{datos.voltaje_conexion}}</td>
            </tr>
            <tr>
              <td>CIE:</td>
              <td></td>
            </tr>
            <tr>
              <td>Asignado:</td>
              <td>{{datos.usuario}}</td>
            </tr>
            <tr>
              <td>Creador:</td>
              <td>{{datos.usuario}}</td>
            </tr>
          </table>
        </div>
        <div class="col-md-4">
            <h3>Presupuesto</h3>
          <table>
            
            <tr>
              <td>Importe</td>
              <td>$ {{datos.importe}}</td>
            </tr>
            <tr>
              <td>Rango de Horas</td>
              <td></td>
            </tr>
            <tr>
              <td>CIE:</td>
              <td></td>
            </tr>
            
          </table>
          <h3>Oficio de CFE / CENACE</h3> {{ nombreOficio  }}
          <button v-if="nombreOficio" type="button" class="btn btn btn-dark" @click="downloadPDF">
            <i class="mdi mdi-pen"></i> {{ nombreOficio }}
          </button>
          <label v-else>No se ha subido</label>
        </div>
        <div class="col-md-4">
          <h3>Solicitud de Inspección</h3> 

          <button type="button" class="btn btn btn-dark" v-if="datos.solicitud_inspeccion == 0 ||
           datos.solicitud_inspeccion == null " @click="enviarSolicitud()">
              <i class="mdi mdi-pen"></i><router-link to="/solicitudinspeccion">Enviar Solicitd </router-link> 
           
          </button>
          <button type="button" class="btn btn btn-dark" v-else>
            <i class="mdi mdi-pen"></i><router-link to="/solicitudinspeccion">Ver Solicitd </router-link> 
         
          </button>

        </div>
      </div>
      <br>
      <div class="col-md-12" style="text-align: left !important;">
        <button type="button" class="btn btn btn-dark" >
            <i class="mdi mdi-pen"></i>
            <router-link  to="/editarcotizacion" style="color: white;"><span>Editar</span></router-link>
        </button> &nbsp;
        <button type="button" class="btn btn btn-dark" >
          <i class="mdi mdi-checkbox-multiple-blank"></i>
          <router-link  to="/cotizacion" style="color: white;"><span>Cotizaciones</span></router-link>
        </button>&nbsp;
        <button type="button" class="btn btn btn-dark"  @click="generatePDF">
          <i class="mdi mdi-file-pdf"></i>
         <span>Pdf</span>
        </button>
      </div>

    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
  
  export default {
    data() {
      return {
        isLoading:false,
        datos: [],
        nombreOficio:''
      }
    },
    created() {
      this.fetchData();
    },
    methods: {
      enviarSolicitud(){
        var id = localStorage.getItem('idcotizacion');
        axios.post(this.$rutaServer+'solicitudInspeccion', { id: id })
          .then(response => {
            if (response.status == 200) {
              Swal.fire('Exito!', 'Se genero con exito la solicitud', 'success');
             
            }
          })
          .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });

      },
      downloadPDF() {
        // URL del archivo PDF en el servidor
        const pdfUrl = 'https://api.seigrupo.com.mx/'+this.datos.oficio_cfe;
        // Crear un enlace invisible para desencadenar la descarga
       /* const link = document.createElement('a');
        link.href = pdfUrl;
        link.setAttribute('download', this.nombreOficio); // Nombre del archivo a descargar
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);*/
 // Abrir el PDF en una nueva pestaña
 window.open(pdfUrl, '_blank');

        
      },
      async generatePDF() {
      try {
        const dateObj = new Date(this.datos.fecha);
        const day = dateObj.getDate().toString().padStart(2, '0');
        const month = dateObj.toLocaleString('es-ES', { month: 'long' });
        const year = dateObj.getFullYear();
        const formattedDate = `${day} de ${month} de ${year}`;

        var enviar = {
          idcotizacion : this.datos.id,
          folio: this.datos.folio,
          razon_social: this.datos.razon_social,
          direccion: this.datos.direccion,
          inspector: this.datos.inspector,
          tipo: this.datos.tipo,
          capacidad:this.datos.capacidad +''+this.datos.unidad,
          voltaje_conexion : this.datos.voltaje_conexion,
          importe: this.datos.importe,
          asignado:this.datos.usuario,
          fecha:formattedDate,
          numero_visitas:this.datos.numero_visitas
        };
        const response = await axios.post('https://api.seigrupo.com.mx/api/generate-pdf',enviar, {
          responseType: 'blob' // Important for binary data
          
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.datos.id+'.pdf'); // or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    },
        regresar(){
        this.$router.push('/cotizacion');
        },
      fetchData() {
        this.isLoading = true;
        var id = localStorage.getItem('idcotizacion');
        axios.post(this.$rutaServer+'datosCotizacion', { id: id })
          .then(response => {
            if (response.status == 200) {
              this.isLoading = false;
              this.datos = response.data.data[0];
            
              if(this.datos.oficio_cfe){
                var arreglo = this.datos.oficio_cfe.split('/');
                this.nombreOficio = arreglo[2];
              }
              
              
              console.log(this.datos);
            }
          })
          .catch(error => {
            Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
      }
    }
  }
  </script>
  
  <style scoped>
  table {
    border-collapse: collapse;
    width: 100%;
  }
  
  table, th, td {
    border: 1px solid black;
  }
  
  th, td {
    padding: 8px;
    text-align: left;
  }
  </style>
  